import { Box } from "@mui/material";
import React from "react";
import { UserWithFullName } from "components/Signals/Dashboard/DashboardMenu/ShareDialog/constants";

const getMentionTokenRegex = () => /@\[([^|\]]+)\|([^\]]+)\]/g;

type CommentTextProps = {
    text: string;
    usersById: Map<string, UserWithFullName>;
};

const CommentText = React.memo(({ text, usersById }: CommentTextProps) => {
    const rendered = React.useMemo(() => {
        const tokenRegex = getMentionTokenRegex();
        const tokenMatches = Array.from(text.matchAll(tokenRegex));
        if (tokenMatches.length > 0) {
            const nodes: React.ReactNode[] = [];
            let lastIndex = 0;
            tokenMatches.forEach((match, index) => {
                const startIndex = match.index ?? 0;
                if (startIndex > lastIndex) {
                    nodes.push(
                        <Box component="span" key={`text-${index}-pre`}>
                            {text.slice(lastIndex, startIndex)}
                        </Box>,
                    );
                }
                const userId = match[1];
                const displayNameInToken = match[2];
                const user = usersById.get(userId);
                const displayName = user?.fullName || displayNameInToken;
                nodes.push(
                    <Box
                        component="span"
                        key={`mention-${index}`}
                        sx={{ fontWeight: 700 }}
                    >
                        @{displayName}
                    </Box>,
                );
                lastIndex = startIndex + match[0].length;
            });
            if (lastIndex < text.length) {
                nodes.push(
                    <Box component="span" key="text-trailing">
                        {text.slice(lastIndex)}
                    </Box>,
                );
            }
            return nodes;
        }

        return text;
    }, [text, usersById]);

    return <>{rendered}</>;
});

export default CommentText;
